<template>
  <div class="world-map">
    <div class="intro">为您打开酒世界</div>
    <div class="intro-split"></div>
    <ECharts :options="options" @click="onClick" />
  </div>
</template>

<script>
import ECharts from "vue-echarts";

import echarts from "echarts/lib/echarts";
import "echarts/map/js/world";
import "echarts/lib/chart/scatter";

export default {
  name: "WorldMap",
  components: {
    ECharts
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let response;

      // 获取原产国数据
      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorCountry",
        methodName: "retrieve",
        params: {
          pageNum: 1,
          numPerPage: 1000
        }
      });
      this.countryList = response.results;

      // 获取地图悬浮提示数据
      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorMap",
        methodName: "retrieve",
        params: {
          pageNum: 1,
          numPerPage: 1000
        }
      });
      this.options.series[0].data = response.results.map(e => {
        return {
          name: e.country,
          value: e.geo
            ? e.geo
                .split(",")
                .map(e => parseFloat(e))
                .concat(e.name)
            : []
        };
      });
      this.options.series[1].data = response.results.map(e => {
        const entry = this.countryList.find(c => c.country == e.country)
          ? true
          : false;

        return {
          name: e.country,
          value: 100,
          item: {
            name: e.name,
            type: e.type || "",
            desc: e.description || "",
            entry: entry
          },
          emphasis: {
            itemStyle: {
              areaColor: entry ? "#FFCA6A" : "#C99537"
            }
          }
        };
      });
    },
    onClick(e) {
      console.log(e);
      const country = this.countryList.find(c => e.name === c.country);

      if (country) {
        this.$router.push("/liquor/country/" + country.id);
      }
    }
  },
  data() {
    return {
      countryList: [],
      options: {
        tooltip: {
          backgroundColor: "#fff",
          padding: 12,
          width: 220,
          extraCssText:
            "border-radius: 10px; border: 2px solid rgba(228, 200, 150, 1);",
          formatter: function(params) {
            if (params.data === undefined) {
              return "";
            }

            const item = params.data.item;

            let desc = "";
            for (let index = 0; index < item.desc.length / 18; index++) {
              desc += item.desc.slice(index * 18, index * 18 + 18) + "<br/>";
            }
            return (
              "<div class='tooltip'>" +
              `<div class='name'>${item.name}</div>` +
              `<div class='split'></div>` +
              `<div class='type'>${item.type}</div>` +
              `<div class='desc'>${desc}</div>` +
              "</div>"
            );
          }
        },
        geo: {
          top: 0,
          bottom: 0,
          map: "world"
          // roam: true
        },
        series: [
          {
            top: 0,
            bottom: 0,
            // roam: true,
            type: "effectScatter",
            coordinateSystem: "geo",
            symbol: "circle",
            symbolSize: 6,
            rippleEffect: {
              scale: 3
            },
            itemStyle: {
              color: "white"
            },
            label: {
              show: true,
              position: [12, 0],
              lineHeight: 8,
              fontWeight: 500,
              formatter: "{@[2]}"
            },
            data: []
            // roam: true
          },
          {
            top: 0,
            bottom: 0,
            // roam: true,
            type: "map",
            map: "world",
            // roam: true,
            itemStyle: {
              areaColor: "#AA7D2D"
            },
            emphasis: {
              itemStyle: {
                // areaColor: "#FFCA6A",
                areaColor: "#C99537"
              }
            },
            data: [],
            nameMap: {
              "Singapore Rep.": "新加坡",
              "Dominican Rep.": "多米尼加",
              Palestine: "巴勒斯坦",
              Bahamas: "巴哈马",
              "Timor-Leste": "东帝汶",
              Afghanistan: "阿富汗",
              "Guinea-Bissau": "几内亚比绍",
              "Côte d'Ivoire": "科特迪瓦",
              "Siachen Glacier": "锡亚琴冰川",
              "Br. Indian Ocean Ter.": "英属印度洋领土",
              Angola: "安哥拉",
              Albania: "阿尔巴尼亚",
              "United Arab Emirates": "阿联酋",
              Argentina: "阿根廷",
              Armenia: "亚美尼亚",
              "French Southern and Antarctic Lands": "法属南半球和南极领地",
              Australia: "澳大利亚",
              Austria: "奥地利",
              Azerbaijan: "阿塞拜疆",
              Burundi: "布隆迪",
              Belgium: "比利时",
              Benin: "贝宁",
              "Burkina Faso": "布基纳法索",
              Bangladesh: "孟加拉国",
              Bulgaria: "保加利亚",
              "The Bahamas": "巴哈马",
              "Bosnia and Herz.": "波斯尼亚和黑塞哥维那",
              Belarus: "白俄罗斯",
              Belize: "伯利兹",
              Bermuda: "百慕大",
              Bolivia: "玻利维亚",
              Brazil: "巴西",
              Brunei: "文莱",
              Bhutan: "不丹",
              Botswana: "博茨瓦纳",
              "Central African Rep.": "中非",
              Canada: "加拿大",
              Switzerland: "瑞士",
              Chile: "智利",
              China: "中国",
              "Ivory Coast": "象牙海岸",
              Cameroon: "喀麦隆",
              "Dem. Rep. Congo": "刚果民主共和国",
              Congo: "刚果",
              Colombia: "哥伦比亚",
              "Costa Rica": "哥斯达黎加",
              Cuba: "古巴",
              "N. Cyprus": "北塞浦路斯",
              Cyprus: "塞浦路斯",
              "Czech Rep.": "捷克",
              Germany: "德国",
              Djibouti: "吉布提",
              Denmark: "丹麦",
              Algeria: "阿尔及利亚",
              Ecuador: "厄瓜多尔",
              Egypt: "埃及",
              Eritrea: "厄立特里亚",
              Spain: "西班牙",
              Estonia: "爱沙尼亚",
              Ethiopia: "埃塞俄比亚",
              Finland: "芬兰",
              Fiji: "斐",
              "Falkland Islands": "福克兰群岛",
              France: "法国",
              Gabon: "加蓬",
              "United Kingdom": "英国",
              Georgia: "格鲁吉亚",
              Ghana: "加纳",
              Guinea: "几内亚",
              Gambia: "冈比亚",
              "Guinea Bissau": "几内亚比绍",
              "Eq. Guinea": "赤道几内亚",
              Greece: "希腊",
              Greenland: "格陵兰",
              Guatemala: "危地马拉",
              "French Guiana": "法属圭亚那",
              Guyana: "圭亚那",
              Honduras: "洪都拉斯",
              Croatia: "克罗地亚",
              Haiti: "海地",
              Hungary: "匈牙利",
              Indonesia: "印度尼西亚",
              India: "印度",
              Ireland: "爱尔兰",
              Iran: "伊朗",
              Iraq: "伊拉克",
              Iceland: "冰岛",
              Israel: "以色列",
              Italy: "意大利",
              Jamaica: "牙买加",
              Jordan: "约旦",
              Japan: "日本",
              Kazakhstan: "哈萨克斯坦",
              Kenya: "肯尼亚",
              Kyrgyzstan: "吉尔吉斯斯坦",
              Cambodia: "柬埔寨",
              Korea: "韩国",
              Kosovo: "科索沃",
              Kuwait: "科威特",
              "Lao PDR": "老挝",
              Lebanon: "黎巴嫩",
              Liberia: "利比里亚",
              Libya: "利比亚",
              "Sri Lanka": "斯里兰卡",
              Lesotho: "莱索托",
              Lithuania: "立陶宛",
              Luxembourg: "卢森堡",
              Latvia: "拉脱维亚",
              Morocco: "摩洛哥",
              Moldova: "摩尔多瓦",
              Madagascar: "马达加斯加",
              Mexico: "墨西哥",
              Macedonia: "马其顿",
              Mali: "马里",
              Myanmar: "缅甸",
              Montenegro: "黑山",
              Mongolia: "蒙古",
              Mozambique: "莫桑比克",
              Mauritania: "毛里塔尼亚",
              Malawi: "马拉维",
              Malaysia: "马来西亚",
              Namibia: "纳米比亚",
              "New Caledonia": "新喀里多尼亚",
              Niger: "尼日尔",
              Nigeria: "尼日利亚",
              Nicaragua: "尼加拉瓜",
              Netherlands: "荷兰",
              Norway: "挪威",
              Nepal: "尼泊尔",
              "New Zealand": "新西兰",
              Oman: "阿曼",
              Pakistan: "巴基斯坦",
              Panama: "巴拿马",
              Peru: "秘鲁",
              Philippines: "菲律宾",
              "Papua New Guinea": "巴布亚新几内亚",
              Poland: "波兰",
              "Puerto Rico": "波多黎各",
              "Dem. Rep. Korea": "朝鲜",
              Portugal: "葡萄牙",
              Paraguay: "巴拉圭",
              Qatar: "卡塔尔",
              Romania: "罗马尼亚",
              Russia: "俄罗斯",
              Rwanda: "卢旺达",
              "W. Sahara": "西撒哈拉",
              "Saudi Arabia": "沙特阿拉伯",
              Sudan: "苏丹",
              "S. Sudan": "南苏丹",
              Senegal: "塞内加尔",
              "Solomon Is.": "所罗门群岛",
              "Sierra Leone": "塞拉利昂",
              "El Salvador": "萨尔瓦多",
              Somaliland: "索马里兰",
              Somalia: "索马里",
              Serbia: "塞尔维亚",
              Suriname: "苏里南",
              Slovakia: "斯洛伐克",
              Slovenia: "斯洛文尼亚",
              Sweden: "瑞典",
              Swaziland: "斯威士兰",
              Syria: "叙利亚",
              Chad: "乍得",
              Togo: "多哥",
              Thailand: "泰国",
              Tajikistan: "塔吉克斯坦",
              Turkmenistan: "土库曼斯坦",
              "East Timor": "东帝汶",
              "Trinidad and Tobago": "特里尼达和多巴哥",
              Tunisia: "突尼斯",
              Turkey: "土耳其",
              Tanzania: "坦桑尼亚",
              Uganda: "乌干达",
              Ukraine: "乌克兰",
              Uruguay: "乌拉圭",
              "United States": "美国",
              Uzbekistan: "乌兹别克斯坦",
              Venezuela: "委内瑞拉",
              Vietnam: "越南",
              Vanuatu: "瓦努阿图",
              "West Bank": "西岸",
              Yemen: "也门",
              "South Africa": "南非",
              Zambia: "赞比亚",
              Zimbabwe: "津巴布韦",
              Comoros: "科摩罗"
            }
          }
        ]
      }
    };
  }
};
</script>

<style lang="scss">
.world-map {
  // margin-top: 200px;
  width: 100%;
  height: 80%;

  z-index: 1002;

  .intro {
    margin: 0 auto;
    width: 224px;
    height: 32px;
    font-size: 32px;
    font-family: "FZQKBYSJW";
    font-weight: 300;
    color: rgba(255, 255, 255, 1);
    line-height: 32px;
    margin-bottom: 25px;
  }

  .intro-split {
    margin: 0 auto;
    margin-bottom: 25px;
    width: 50px;
    height: 1px;
    background: rgba(255, 255, 255, 1);
  }

  .echarts {
    z-index: 1003;
    width: 100%;
    height: 100%;
  }
}

.tooltip {
  width: 220px;
  //   background: rgba(255, 255, 255, 1);
  //   border-radius: 10px;
  //   padding: 10px;

  .name {
    display: inline-block;
    height: 20px;
    font-size: 18px;
    font-family: "FZQKBYSJW";
    font-weight: normal;
    color: rgba(59, 41, 9, 1);
    line-height: 20px;
  }

  .split {
    display: inline-block;
    width: 1px;
    margin: 0 10px;
    height: 13px;
    background: rgba(228, 200, 150, 1);
  }

  .type {
    display: inline-block;
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(59, 41, 9, 1);
    line-height: 17px;
  }

  .desc {
    // display: inline-block;
    margin-top: 10px;
    width: 196px;
    // height: 200px;
    // min-height: 200px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(119, 82, 17, 1);
    line-height: 17px;
  }
}
</style>